export default "__VITE_ASSET__HBaBPb17__ 584w";